module.exports = __webpack_public_path__ + "static/light-logo-85061522b6bbb627b9a19b56a1ba43ef.png";